import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { showBalancesPopupAction } from '../../../../../popups/BalancesPopup';

export const useBalancesPopupHandler = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const invokeBalancesPopup = () => {
            dispatch(showBalancesPopupAction());
        };

        dispatcher.listen('user:action:balancesPopup', invokeBalancesPopup);

        return () => {
            dispatcher.removeListener('user:action:balancesPopup', invokeBalancesPopup);
        };
    }, [dispatch]);
};
